import { useAuth } from '../contexts/AuthContext'
import { LoginForm } from './LoginForm'

interface AuthGuardProps {
  children: React.ReactNode
  /** Wire role(s) in `ROLE_*` form — any-of when an array is passed. */
  requiredRole?: string | string[]
}

export const AuthGuard = ({ children, requiredRole }: AuthGuardProps) => {
  const { isAuthenticated, user, loading } = useAuth()

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen text-zinc-400">Loading...</div>
  }

  if (!isAuthenticated) {
    return <LoginForm />
  }

  const allowed = requiredRole == null
    || (Array.isArray(requiredRole) ? requiredRole : [requiredRole]).includes(user?.role ?? '')
  if (!allowed) {
    return <div className="flex items-center justify-center min-h-screen text-red-500">Access Denied</div>
  }

  return <>{children}</>
}
